import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.primary };
  cursor: pointer;
  text-decoration: none;
`;

export default StyledLink;



// WEBPACK FOOTER //
// ./src/components/StyledLink/index.js